import { cloneElement, FC, ReactElement, ReactNode } from "react";
import { ScrollView, StyleProp, StyleSheet, View, ViewStyle } from "react-native";
import { useSelector } from "react-redux";
import { kColors } from "../kColors";
import { kStyleConst } from "../kStyle";

type tModalDisplay = {
  modal: ReactElement;
  isVisible: boolean;
  key: string;
};

type tPageContainerProps = {
  children: ReactNode;
  scrollViewContainerStyle?: StyleProp<ViewStyle>;
  scrollViewStyle?: StyleProp<ViewStyle>;
  viewStyle?: StyleProp<ViewStyle>;
  modals?: Array<tModalDisplay>;
  marginStart?: number;
  marginEnd?: number;
  marginTop?: number;
  marginBottom?: number;
  bottomToolbar?: ReactNode;
};

const PageContainer: FC<tPageContainerProps> = ({
  children,
  scrollViewContainerStyle,
  modals,
  scrollViewStyle,
  marginStart,
  marginEnd,
  marginTop,
  marginBottom,
  bottomToolbar,
  viewStyle,
}) => {
  const rIsMobile = useSelector(
    (state) => state.NavigationReducer.deviceSize === "xs" || state.NavigationReducer.deviceSize === "sm",
  );
  return (
    <>
      {modals &&
        modals.map((myModal) =>
          myModal.isVisible ? cloneElement(myModal.modal, { key: myModal.key }) : <View key={`${Math.random()}`} />,
        )}
      <ScrollView
        contentContainerStyle={scrollViewContainerStyle}
        style={scrollViewStyle ? scrollViewStyle : styles.gStackScreenDefault}
      >
        <View
          style={[
            rIsMobile ? styles.containerMobile : styles.container,
            marginStart ? { marginStart } : null,
            marginEnd ? { marginEnd } : null,
            marginTop ? { marginTop } : null,
            marginBottom ? { marginBottom } : null,
            viewStyle,
          ]}
        >
          {children}
        </View>
      </ScrollView>
      {bottomToolbar ? bottomToolbar : null}
    </>
  );
};

export default PageContainer;

const styles = StyleSheet.create({
  container: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    marginHorizontal: 10 * kStyleConst.kSpacing,
    marginVertical: 5 * kStyleConst.kSpacing,
  },
  containerMobile: {
    backgroundColor: kColors.white,
    flexGrow: 1,
    marginHorizontal: 5 * kStyleConst.kSpacing,
    marginVertical: 2 * kStyleConst.kSpacing,
  },
  gStackScreenDefault: {
    backgroundColor: kColors.white,
    flex: 1,
  },
});
